import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserIdNameApiModel } from '@app/api/api-models/users/UserIdNameApiModel';
import { toQueryParams } from 'src/app/shared/utils';
import {
  AddAttendeesToTrainingCourseClassApiModel,
  TrainingCourseClassAttendeeApiModel,
  TrainingCourseClassAttendeeBulkGradingApiModel,
  TrainingCourseClassAttendeeBulkMessageApiModel,
  TrainingCourseClassAttendeeGradingApiModel
} from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class TrainingCourseClassAttendeesService {
  public apiUrl = 'training-course-class-attendees';

  constructor(private readonly http: HttpClientService) {}

  public getPossible(trainingCourseClassId: number): Observable<UserIdNameApiModel[]> {
    const params = toQueryParams({
      trainingCourseClassId: trainingCourseClassId
    });

    return this.http.get<UserIdNameApiModel[]>(`${this.apiUrl}/possible`, { params: params });
  }

  public add(model: AddAttendeesToTrainingCourseClassApiModel): Observable<TrainingCourseClassAttendeeApiModel[]> {
    return this.http.post<TrainingCourseClassAttendeeApiModel[]>(`${this.apiUrl}`, model);
  }

  public assignQuiz(id: number): Observable<TrainingCourseClassAttendeeApiModel> {
    return this.http.put<TrainingCourseClassAttendeeApiModel>(`${this.apiUrl}/${id}/assign-quiz`, null);
  }

  public assignGrading(
    model: TrainingCourseClassAttendeeGradingApiModel
  ): Observable<TrainingCourseClassAttendeeApiModel> {
    return this.http.put<TrainingCourseClassAttendeeApiModel>(`${this.apiUrl}/assign-grading`, model);
  }

  public bulkAssignGrading(
    model: TrainingCourseClassAttendeeBulkGradingApiModel
  ): Observable<TrainingCourseClassAttendeeApiModel[]> {
    return this.http.put<TrainingCourseClassAttendeeApiModel[]>(`${this.apiUrl}/bulk-assign-grading`, model);
  }

  public bulkAssignQuiz(ids: number[]): Observable<TrainingCourseClassAttendeeApiModel[]> {
    return this.http.put<TrainingCourseClassAttendeeApiModel[]>(`${this.apiUrl}/bulk-assign-quiz`, ids);
  }

  public bulkSendMessage(model: TrainingCourseClassAttendeeBulkMessageApiModel): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/bulk-send-message`, model);
  }

  public bulkDelete(ids: number[]): Observable<TrainingCourseClassAttendeeApiModel[]> {
    return this.http.put<TrainingCourseClassAttendeeApiModel[]>(`${this.apiUrl}/bulk-delete`, ids);
  }
}
